import FileSaver from 'file-saver';
import XLSX from 'xlsx';

const htmlToExcel = {
    // 格式化数据
    getExcel(dom, title = '默认标题',) {
        var excelTitle = title;
        var wb = XLSX.utils.table_to_book(document.querySelector(dom),{ raw: true });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
        try {
            FileSaver.saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                excelTitle + ".xlsx"
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
};

// const htmlToExcel = {
//     // 格式化数据并导出Excel
//     getExcel(dom, title = '默认标题') {
//         var excelTitle = title;
//         // 获取要导出的数据
//         var table = document.querySelector(dom);
//         var rows = Array.from(table.querySelectorAll("tr"));
//
//         // 格式化数据，保留两位小数
//         var formattedData = rows.map(row => {
//             var cells = Array.from(row.querySelectorAll("td"));
//             return cells.map(cell => {
//                 var value = cell.innerText.trim();
//                 if (!isNaN(parseFloat(value))) {
//                     return parseFloat(value).toFixed(2); // 保留两位小数
//                 } else {
//                     return value;
//                 }
//             });
//         });
//
//         // 创建Excel对象
//         var wb = XLSX.utils.book_new();
//         wb.SheetNames.push(excelTitle);
//         var ws = XLSX.utils.aoa_to_sheet(formattedData);
//         wb.Sheets[excelTitle] = ws;
//
//         // 导出Excel文件
//         var wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
//         try {
//             FileSaver.saveAs(
//                 new Blob([wbout], { type: "application/octet-stream" }),
//                 excelTitle + ".xlsx"
//             );
//         } catch (e) {
//             if (typeof console !== "undefined") console.log(e, wbout);
//         }
//         return wbout;
//     }
// };


export default htmlToExcel;
